import { Link } from "wouter";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";

export default function Privacy() {
  return (
    <div className="min-h-screen bg-background py-10">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <Link href="/">
            <Button variant="ghost" className="flex items-center gap-1 hover:bg-transparent hover:text-primary p-0">
              <ChevronLeft className="h-4 w-4" />
              <span>Back to Home</span>
            </Button>
          </Link>
        </div>
        
        <div className="max-w-3xl mx-auto bg-card p-8 rounded-lg shadow-sm">
          <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
          
          <div className="prose dark:prose-invert max-w-none">
            <p className="mb-4">
              At NoLicense Nearby, we value your privacy and are committed to protecting your personal information. 
              This Privacy Policy explains how we collect, use, and safeguard your data when you use our music licensing platform.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Information We Collect</h2>
            <p className="mb-4">
              We collect information that you provide directly to us when you:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Create an account</li>
              <li>Submit a license request</li>
              <li>Make a payment</li>
              <li>Contact our support team</li>
              <li>Participate in our referral program</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">How We Use Your Information</h2>
            <p className="mb-4">
              We use the information we collect to:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Process your license requests and payments</li>
              <li>Provide you with the music tracks you've licensed</li>
              <li>Improve our services and user experience</li>
              <li>Communicate with you about your account and transactions</li>
              <li>Administer our referral program</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Information Sharing</h2>
            <p className="mb-4">
              We do not sell or rent your personal information to third parties. We may share your information with:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Payment processors (Stripe) to complete transactions</li>
              <li>Service providers who help us operate our platform</li>
              <li>Law enforcement when required by law</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Data Security</h2>
            <p className="mb-4">
              We implement appropriate security measures to protect your personal information from unauthorized access, 
              alteration, disclosure, or destruction. However, no method of transmission over the Internet or electronic 
              storage is 100% secure.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Your Rights</h2>
            <p className="mb-4">
              You have the right to:
            </p>
            <ul className="list-disc pl-6 mb-4">
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Opt out of marketing communications</li>
            </ul>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Contact Us</h2>
            <p className="mb-4">
              If you have any questions about this Privacy Policy, please contact us through our license request form.
            </p>
            
            <h2 className="text-xl font-semibold mt-6 mb-3">Changes to This Policy</h2>
            <p className="mb-4">
              We may update this Privacy Policy from time to time. The updated version will be indicated by an updated 
              "Last Updated" date at the top of this page.
            </p>
            
            <p className="mt-8 text-sm text-muted-foreground">
              Last Updated: March 25, 2025
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}